import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  selectFile: () => __(translations.dragAndDrop.selectFile, 'Select or drap a file…'),
};
